// src/Pages/DashboardManagment/AdminDashboard.jsx

import React, { useEffect, useMemo, useState } from "react";
import {
  getDashboardCountList,
  getTodayDashboardCountList,
  PieCharData,
} from "../../redux/services/dashboardServices/dashboard.Services";
import Chart from "react-apexcharts";
import { Link, useNavigate } from "react-router";
import {
  MdDashboard,
  MdHomeWork,
  MdPeople,
  MdAttachMoney,
  MdOutlineAnalytics,
  MdRateReview,
  MdNotifications,
  MdLocationCity,
  MdCategory,
  MdBusinessCenter,
  MdQuestionAnswer,
  MdArticle,
  MdTrendingUp,
  MdArrowUpward,
  MdAutoAwesome,
  MdRefresh,
  MdCalendarToday,
} from "react-icons/md";
import heroImage from "../../assets/image/crm-dashboard-hero.png";
import { getUserRole, getAdminData } from "../../Utils/role";
import { FiGrid } from "react-icons/fi";
const iconMap = {
  dashboard: MdDashboard,
  states: MdLocationCity,
  cities: MdLocationCity,
  amenities: MdCategory,
  property: MdHomeWork,
  owner: MdBusinessCenter,
  customers: MdPeople,
  revenue: MdAttachMoney,
  reports: MdOutlineAnalytics,
  reviews: MdRateReview,
  blogs: MdArticle,
  faq: MdQuestionAnswer,
  notification: MdNotifications,
};

const accentMap = {
  cyan: "#22d3ee",
  amber: "#fbbf24",
  violet: "#a78bfa",
  rose: "#fb7185",
  indigo: "#818cf8",
  emerald: "#34d399",
  sky: "#38bdf8",
  red: "#f87171",
};

const AdminDashboard = () => {
  const role = getUserRole();
  const navigate = useNavigate();
  const isAdmin = getAdminData();          
  const adminData = getAdminData() || {};   
  const [pieChartData, setPieChartData] = useState([]);
  const [summary, setSummary] = useState({});
  const [todaySummary, setTodaySummary] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [activeTab, setActiveTab] = useState("total");

  const fetchDashboard = async (showRefresh = false) => {
    try {
      if (showRefresh) setRefreshing(true);
      const [dashboardRes, todayRes, pieRes] = await Promise.all([
        getDashboardCountList(),
        getTodayDashboardCountList(),
        PieCharData(),
      ]);
      setSummary(dashboardRes?.data || {});
      if (todayRes?.success) setTodaySummary(todayRes.data || {});
      setPieChartData(pieRes?.data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  const totalTiles = useMemo(
    () => [
      {
        icon: "dashboard",
        label: "Total Leads",
        // href: "/all-lead-list",
        href: "/lead-list",
        points: summary?.total_leads || 0,
        accent: "cyan",
        helper: "All captured leads",
      },
      {
        icon: "notification",
        label: "Pending Leads",
        href:
          role === "vender"
            ? "/vendor-pending-lead-list"
            : "/staff-pending-lead-list",
        points: summary?.pending_leads || 0,
        accent: "amber",
        helper: "Need follow-up",
      },
      {
        icon: "owner",
        label: "Converted Leads",
        // href: "/admin-converted-lead-list",
        href: "/lead-list",
        points: summary?.converted_leads || 0,
        accent: "violet",
        helper: "Successfully converted",
      },
      // {
      //   icon: "customers",
      //   label: "Lost Leads",
      //   href: "/admin-lost-lead-list",
      //   points: summary?.lost_leads || 0,
      //   accent: "rose",
      //   helper: "Closed as lost",
      // },
      ...(isAdmin
        ? [
            // {
            //   icon: "owner",
            //   label: "Total Staff",
            //   href: "/staff-list",
            //   points: summary?.all_staff || 0,
            //   accent: "indigo",
            //   helper: "Team members",
            // },
            // {
            //   icon: "owner",
            //   label: "Active Staff",
            //   href: "/logged-staff-list",
            //   points: summary?.login_staff || 0,
            //   accent: "emerald",
            //   helper: "Currently active",
            // },
            // {
            //   icon: "owner",
            //   label: "Assigned Leads",
            //   href: "/admin-assign-lead-list",
            //   points: summary?.assigned_leads || 0,
            //   accent: "sky",
            //   helper: "Assigned to staff",
            // },
            // {
            //   icon: "dashboard",
            //   label: "Unassigned Leads",
            //   href: "/admin-unassign-lead-list",
            //   points: summary?.unassigned_lead || 0,
            //   accent: "red",
            //   helper: "Waiting for assignment",
            // },
            // {
            //   icon: "notification",
            //   label: "Total Renewal",
            //   href: "/renewal-list",
            //   points: summary?.total_renewal || 0,
            //   accent: "indigo",
            //   helper: "All renewals",
            // },
            // {
            //   icon: "notification",
            //   label: "Pending Renewal",
            //   href: "/pending-renewal-list",
            //   points: summary?.pending_renewal || 0,
            //   accent: "amber",
            //   helper: "Renewals pending",
            // },
          ]
        : []),
    ],
    [summary, role, isAdmin]
  );

  const todayTiles = useMemo(
    () => [
      {
        icon: "dashboard",
        label: "Today's Leads",
        // href: "/today-all-lead-list",
        points: todaySummary?.today_total_leads || 0,
        accent: "cyan",
        helper: "Captured today",
      },
      {
        icon: "dashboard",
        label: "Pending Leads",
        href: "/today-pending-lead-list",
        // points: todaySummary?.today_pending_leads || 0,
        accent: "amber",
        helper: "Pending today",
      },
      {
        icon: "notification",
        label: "Converted Leads",
        // href: "/today-converted-lead-list",
        points: todaySummary?.today_converted_leads || 0,
        accent: "violet",
        helper: "Converted today",
      },
      // {
      //   icon: "owner",
      //   label: "Lost Leads",
      //   href: "/today-lost-lead-list",
      //   points: todaySummary?.today_lost_leads || 0,
      //   accent: "rose",
      //   helper: "Lost today",
      // },
      ...(isAdmin
        ? [
            {
              icon: "owner",
              label: "Today's New Staff",
              href: "/today-new-staff-list",
              points: todaySummary?.today_all_staff || 0,
              accent: "indigo",
              helper: "Joined today",
            },
            {
              icon: "owner",
              label: "Assigned Leads",
              href: "/today-assigned-lead-list",
              points: todaySummary?.today_assigned_leads || 0,
              accent: "emerald",
              helper: "Assigned today",
            },
            {
              icon: "dashboard",
              label: "Unassigned Leads",
              href: "/today-unassigned-lead-list",
              points: todaySummary?.today_unassigned_lead || 0,
              accent: "sky",
              helper: "Need assignment",
            },
            // {
            //   icon: "notification",
            //   label: "Today's Renewal",
            //   href: "/today-renewal-list",
            //   points: todaySummary?.today_renewal || 0,
            //   accent: "emerald",
            //   helper: "Renewed today",
            // },
          ]
        : []),
    ],
    [todaySummary, isAdmin]
  );
  const displayedTiles = activeTab === "total" ? totalTiles : todayTiles;
  const hour = new Date().getHours();
  const greeting =
    hour < 12 ? "Good morning" : hour < 18 ? "Good afternoon" : "Good evening";
  const displayName = adminData?.name || adminData?.username || "Vendor";
  const totalLeads = Number(summary?.total_leads || 0);
  const convertedLeads = Number(summary?.converted_leads || 0);
  const pendingLeads = Number(summary?.pending_leads || 0);
  const conversionRate = totalLeads
    ? ((convertedLeads / totalLeads) * 100).toFixed(1)
    : "0.0";
  const pendingRate = totalLeads
    ? ((pendingLeads / totalLeads) * 100).toFixed(1)
    : "0.0";

  const chartColors = [
    "#22d3ee",
    "#818cf8",
    "#34d399",
    "#fbbf24",
    "#fb7185",
    "#38bdf8",
  ];

  const safePieData = (Array.isArray(pieChartData) ? pieChartData : [])
    .map((item) => ({
      source: item?.source ? String(item.source) : "Not set",
      total: Number(item?.total) || 0,
    }))
    .filter((item) => item.total > 0);

  const leadSourceOptions = {
    labels: safePieData.map((item) => item.source),
    colors: chartColors,
    chart: {
      background: "transparent",
      toolbar: { show: false },
      foreColor: "#94a3b8",
    },
    legend: {
      position: "bottom",
      labels: { colors: "#cbd5e1" },
      markers: { radius: 4 },
      itemMargin: { horizontal: 10, vertical: 5 },
    },
    stroke: { show: false },
    dataLabels: { enabled: false },
    plotOptions: { pie: { donut: { size: "72%" } } },
    tooltip: { theme: "dark" },
  };

  const leadSourceSeries = safePieData.map((item) => item.total);

  const staffOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      foreColor: "#94a3b8",
      background: "transparent",
    },
    colors: ["#22d3ee", "#818cf8", "#34d399"],
    plotOptions: {
      bar: {
        columnWidth: "42%",
        borderRadius: 6,
        borderRadiusApplication: "end",
      },
    },
    grid: { borderColor: "rgba(148,163,184,.12)", strokeDashArray: 4 },
    xaxis: {
      categories:
        summary?.staffPerformance?.length > 0
          ? summary.staffPerformance.map((s) => s?.name || "Staff")
          : ["Team A", "Team B", "Team C", "Team D"],
      labels: { style: { colors: "#94a3b8", fontSize: "11px" } },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: { labels: { style: { colors: "#64748b" } } },
    legend: {
      position: "bottom",
      labels: { colors: "#cbd5e1" },
      markers: { radius: 4 },
    },
    tooltip: { theme: "dark" },
    dataLabels: { enabled: false },
  };

  const staffSeries = [
    {
      name: "Assigned",
      data:
        summary?.staffPerformance?.length > 0
          ? summary.staffPerformance.map((s) => Number(s?.assignedLeads) || 0)
          : [120, 90, 150, 80],
    },
    {
      name: "Follow-ups",
      data:
        summary?.staffPerformance?.length > 0
          ? summary.staffPerformance.map((s) => Number(s?.followupsDone) || 0)
          : [100, 70, 130, 60],
    },
    {
      name: "Converted",
      data:
        summary?.staffPerformance?.length > 0
          ? summary.staffPerformance.map((s) => Number(s?.convertedLeads) || 0)
          : [30, 20, 45, 15],
    },
  ];

  if (isLoading) {
    return (
      <div className="crm-dashboard-loading">
        <div className="crm-loader-ring" />
        <strong>Preparing your command center</strong>
        <span>Loading live dashboard data…</span>
      </div>
    );
  }

  return (
    <div className="crm-dashboard">
      <section className="crm-dashboard-hero">
        <img src={heroImage} alt="AI powered CRM analytics" />
        <div className="crm-hero-glow" />
        <div className="crm-hero-content">
          <div className="crm-ai-badge">

    
            <MdAutoAwesome size={15} />
            AI-powered CRM command center
          </div>
          <h1>
            {greeting}, <span>{displayName}</span>
          </h1>
          <p>
            Monitor leads, team performance and conversions from one focused
            workspace.
          </p>
          <div className="crm-hero-meta">
            <span>
              <MdCalendarToday size={15} />{" "}
              {new Date().toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </span>
            <button
              onClick={() => fetchDashboard(true)}
              disabled={refreshing}
            >
              <MdRefresh className={refreshing ? "crm-spin" : ""} size={16} />
              {refreshing ? "Refreshing" : "Refresh data"}
            </button>

            <button
  className="btn-our-services"
  onClick={() => navigate("/our-services")}
>
  <FiGrid /> Other Services
</button>
          </div>
        </div>
        <div className="crm-hero-stats">
          <div>
            <span>Conversion</span>
            <strong>{conversionRate}%</strong>
            <small>
              <MdArrowUpward /> Live rate
            </small>
          </div>
          <div>
            <span>Pending share</span>
            <strong>{pendingRate}%</strong>
            <small>
              <MdTrendingUp /> Of total leads
            </small>
          </div>
        </div>
      </section>

      <section className="crm-section-head">
        <div>
          <span className="crm-eyebrow">Performance overview</span>
          <h2>
            {activeTab === "total" ? "Business snapshot" : "Today's snapshot"}
          </h2>
        </div>
        <div className="crm-view-switch">
          <button
            className={activeTab === "total" ? "active" : ""}
            onClick={() => setActiveTab("total")}
          >
            Overall
          </button>
          <button
            className={activeTab === "today" ? "active" : ""}
            onClick={() => setActiveTab("today")}
          >
            Today
          </button>
        </div>
      </section>

      <section className="crm-kpi-grid">
        {displayedTiles.map((item, index) => {
          const IconComponent = iconMap[item.icon] || MdDashboard;
          const accent = accentMap[item.accent] || accentMap.cyan;
          const cardBody = (
            <>
              <div className="crm-kpi-top">
                <div className="crm-kpi-icon">
                  <IconComponent size={21} />
                </div>
                <span className="crm-kpi-arrow">↗</span>
              </div>
              <div className="crm-kpi-value">
                {Number(item.points || 0).toLocaleString("en-IN")}
              </div>
              <div className="crm-kpi-label">{item.label}</div>
              <div className="crm-kpi-helper">{item.helper}</div>
              <div className="crm-kpi-line" />
            </>
          );
          return item.href ? (
            <Link
              to={item.href}
              className="crm-kpi-card"
              key={`${item.label}-${index}`}
              style={{ "--accent": accent }}
            >
              {cardBody}
            </Link>
          ) : (
            <div
              className="crm-kpi-card"
              key={`${item.label}-${index}`}
              style={{ "--accent": accent }}
            >
              {cardBody}
            </div>
          );
        })}
      </section>

      {isAdmin && (
        <section className="crm-chart-grid">
          <div className="crm-chart-card crm-source-card">
            <div className="crm-card-heading">
              <div>
                <span className="crm-eyebrow">Lead intelligence</span>
                <h3>Lead sources</h3>
              </div>
              <span className="crm-live-dot">LIVE</span>
            </div>
            <div className="crm-chart-body">
              {safePieData.length > 0 ? (
                <Chart
                  options={leadSourceOptions}
                  series={leadSourceSeries}
                  type="donut"
                  height={310}
                />
              ) : (
                <div className="crm-empty-chart">No source data available</div>
              )}
            </div>
          </div>

          <div className="crm-chart-card">
            <div className="crm-card-heading">
              <div>
                <span className="crm-eyebrow">Team analytics</span>
                <h3>Staff performance</h3>
              </div>
              <span className="crm-period-chip">Current data</span>
            </div>
            <div className="crm-chart-body">
              <Chart
                options={staffOptions}
                series={staffSeries}
                type="bar"
                height={310}
              />
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default AdminDashboard;